import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Badges, BadgeStatus, ScorecardService } from '@fgb/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

import { ScorecardDescriptionComponent } from '@fgb/portal-component-library/src/lib/loyalty/scorecards';
import { Router } from '@angular/router';

@Component({
  selector: 'fgbcl-badge-list-item',
  templateUrl: './badge-list-item.component.html',
  styleUrls: ['./badge-list-item.component.scss'],
})
export class BadgeListItemComponent implements OnInit {
  @Input() badge: Badges;
  @Input() confettiColors: string[];
  BadgeStatus = BadgeStatus;
  preventMultipleClick: boolean = false;
  isOpenModal: boolean = true;
  @Input() isSponsorInBody: boolean = false;
  @Input() isShowName: boolean = true;
  constructor(
    private offcanvasService: NgbOffcanvas,
    private scorecardService: ScorecardService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.onWindowResize(window.screen.width);
  }

  @HostListener('window:resize', ['$event.target.screen.width'])
  onWindowResize(event: number) {
    if (event > 991) {
      this.isOpenModal = true;
    } else {
      this.isOpenModal = false;
    }
  }

  openScorecardDescription() {
    this.isOpenModal ? this.openModal() : this.redirectComponent();
  }

  openModal() {
    const badgeOffcanvasEl = document.getElementById('allBadgesAchieved');
    if (badgeOffcanvasEl) {
      (window as any).bootstrap?.Offcanvas?.getInstance(badgeOffcanvasEl)?.hide();
    }
    const offcanvasRef = this.offcanvasService.open(ScorecardDescriptionComponent, {
      position: 'bottom',
      panelClass: 'scorecard-offcanvas-content',
    });
    offcanvasRef.componentInstance.confettiColors = this.confettiColors;
    offcanvasRef.componentInstance.scorecardId = this.badge.ScorecardId;
    offcanvasRef.componentInstance.isSponsorInBody = this.isSponsorInBody;
  }

  redirectComponent() {
    const initVal = {
      confettiColors: this.confettiColors,
    };
    let params = this.isSponsorInBody ? { isSponsorInBody: this.isSponsorInBody } : {};

    this.scorecardService.initDataScorecardDescription$.next(initVal);
    this.router.navigate(['/scorecard-description', this.badge.ScorecardId, params]);
  }
}
